module.exports = __webpack_public_path__ + "Panton-Bold.e329e3b7b6da.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Panton-Bold.ttf
// module id = ./src/styles/fonts/Panton-Bold.ttf
// module chunks = 21